import React, { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import Select from "react-select";

const RetriggerModal = ({
  show,
  handleClose,
  handleConfirm,
  message,
  comment,
  setComment,
  retriggerToRole,
  setRetriggerToRole,
  availableRoles,
  roleId,
  item,
  loanType,
}) => {
  const [validationError, setValidationError] = useState("");
  
  // If availableRoles is provided, use it directly
  let options = [];
  
  if (availableRoles && availableRoles.length > 0) {
    options = availableRoles.map((role) => ({
      label: role,
      value: role,
    }));
  } else {
    // Otherwise, use the original logic for dynamic role calculation
    const dynamicRoles = [];

    if (loanType === "Business Loan") {
      // CRO option
      if (["MIS", "Credit Manager", "Sanction Committee", "Branch Manager", "Accounts Manager"].includes(roleId)) {
        dynamicRoles.push({ label: "Customer Relationship Officer", value: "Customer Relationship Officer" });
      }
      // BM option
      if (["MIS", "Credit Manager", "Sanction Committee", "Accounts Manager"].includes(roleId)) {
        dynamicRoles.push({ label: "Branch Manager", value: "Branch Manager" });
      }
      // CO option
      if ((roleId === "MIS" && ["pending", "retrigger"].includes(item.misStatus)) || roleId === "Credit Manager" || roleId === "Sanction Committee") {
        dynamicRoles.push({ label: "Credit Officer", value: "Credit Officer" });
      }
      // MIS option
      if (roleId === "Credit Manager" || roleId === "Sanction Committee") {
        dynamicRoles.push({ label: "MIS", value: "MIS" });
      }
      // CM option
      if (roleId === "Sanction Committee") {
        dynamicRoles.push({ label: "Credit Manager", value: "Credit Manager" });
      }
    } else {
      // Original logic for GP Loan or others
      if (["Branch Manager", "MIS", "Credit Manager", "Accounts Manager"].includes(roleId)) {
        dynamicRoles.push({ label: "Customer Relationship Officer", value: "Customer Relationship Officer" });
      }
      if (["MIS", "Credit Manager", "Accounts Manager"].includes(roleId)) {
        dynamicRoles.push({ label: "Branch Manager", value: "Branch Manager" });
      }
      if (roleId === "Credit Manager" || roleId === "MIS") {
        dynamicRoles.push({ label: "MIS", value: "MIS" });
      }
    }

    options = dynamicRoles;
  }

  const handleClick = () => {
    if (!comment || !retriggerToRole) {
      setValidationError("Please fill all fields");
    } else {
      setValidationError("");
      handleConfirm();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
        <Form.Group>
          <Form.Label>Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter Comment"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            required
          />
        </Form.Group>
        <Form.Label>Retrigger To</Form.Label>
        <Select
          value={options.find((option) => option.value === retriggerToRole)}
          onChange={(selectedOption) =>
            setRetriggerToRole(selectedOption ? selectedOption.value : "")
          }
          options={options}
          placeholder="-- Select Role --"
          isClearable
        />
        {validationError && <p style={{ color: "red" }}>{validationError}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleClick}>
          Retrigger
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RetriggerModal;

